import React from 'react';
import PropTypes from 'prop-types';
import ReportIssueBase from '../reportIssue/ReportIssueBase';

const BadState = ({ ...props }) => {
  const { mobile, motiveId, product, type, profile, onData } = props;

  return (
    <ReportIssueBase
      mobile={mobile}
      motiveId={motiveId}
      product={product}
      type={type}
      profile={profile}
      onData={onData}
      name="BadState"
      label="Descríbenos el estado en que llegó tu producto…"
      buttonText="Enviar autorización"
    />
  );
};

BadState.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  onData: PropTypes.func,
};

export default BadState;
